import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { usePrimitiveText } from "@/v2-ui/text/offline"

export type ErrorMessageProps = Omit<ComponentProps<"div">, "children"> & {
  error?: Error | string
}

function ErrorMessage(props: ErrorMessageProps) {
  const { getText } = usePrimitiveText()
  const { error, className, ...divProps } = props

  const errorMessage = typeof error === "string" ? error : error?.message

  if (!errorMessage) return null

  return (
    <div
      className={cn("error-message text-red-600 px-3", className)}
      role="alert"
      aria-label={getText("UI_Primitive_ErrorMessage_Root").Name}
      {...divProps}
    >
      {errorMessage}
    </div>
  )
}

export default ErrorMessage
